module.exports = {
    //baseUrl: 'https://customerapi.livefacetof.com', // 正式项目地址
    //wsurl: 'wss://customerapi.livefacetof.com/staff',
    baseUrl: 'https://fifa2-customerapi.hsglm.com',
    wsurl: 'wss://fifa2-customerapi.hsglm.com/staff',
}